(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cs-growth-chart"] && !Shopify.designMode) return;
  try {
    (function initGrowthChart() {
  function tryInit() {
    var clipRect = document.getElementById('cs-chart-clip-rect');
    if (!clipRect || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return setTimeout(tryInit, 100);
    }
    gsap.registerPlugin(ScrollTrigger);

    var markers = document.querySelectorAll('#cs-chart-milestones .cs-chart__marker');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced) {
      // Skip animation — leave SVG defaults (full width + visible markers) as-is.
      return;
    }

    // Snap to hidden state BEFORE the trigger fires (no flash of unstyled content
    // because GSAP applies synchronously).
    gsap.set('#cs-chart-clip-rect', { attr: { width: 0 } });
    markers.forEach(function (m) { gsap.set(m, { opacity: 0, y: 4 }); });

    ScrollTrigger.create({
      trigger: '#cs-growth-chart',
      start: 'top 80%',
      once: true,
      onEnter: function () {
        gsap.to('#cs-chart-clip-rect', {
          attr: { width: 840 },
          duration: 2.2,
          ease: 'power2.inOut'
        });
        gsap.to(markers, {
          opacity: 1,
          y: 0,
          duration: 0.45,
          ease: 'power2.out',
          stagger: 0.4,
          delay: 0.4
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
